import Icon from '../../Icons'

export const customStyles = {
  option: (provided, state) => ({
    ...provided,
    background: state.isSelected ? 'lightgray' : state.isFocused ? '#dbdbdb' : '',
    padding: 3,
    '&:hover': {
      backgroundColor: '#dbdbdb',
    },
    fontSize: '14px',
    color: state.isDisabled ? '#828282' : '',
  }),
  menu: (styles) => ({
    ...styles,
    zIndex: 9,
    maxHeight: '140px',
  }),
  menuList: (styles) => ({
    ...styles,
    maxHeight: '140px',
  }),
  container: (styles) => ({
    ...styles,
    minWidth: '230px',
  }),
  control: (styles, state) => ({
    ...styles,
    fontSize: '1em',
    border: `1px solid ${state.isFocused ? '#000000' : '#dbdbdb'}`,
    '&:hover': {
      border: `1px solid ${state.isFocused ? '#000000' : '#b5b5b5'}`,
    },
    boxShadow: 'none',
    background: state.isDisabled ? '#E7E7E7' : '',
    color: state.isDisabled ? '#828282' : '',
    minHeight: '40px',
  }),
  valueContainer: (styles) => ({
    ...styles,
    maxHeight: '115px',
    overflowY: 'auto',
  }),
  singleValue: (provided) => {
    const transition = 'opacity 300ms'
    return { ...provided, transition }
  },
  placeholder: (styles) => ({
    ...styles,
    fontSize: '1em',
    color: '#8d8c8c',
    textAlign: 'center',
    fontWeight: '400',
  }),
}

export const DropdownIndicator = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '5px',
        width: '28px',
      }}
    >
      <Icon icon="search" fill="#dbdbdb" />
    </div>
  )
}
